import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;

export const HighGuardBadge = ({ pair, guard, price, formatPrice }) => {
  const [allowed, setAllowed] = useState(!!guard?.high_buy_allowed);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setAllowed(!!guard?.high_buy_allowed); }, [guard?.high_buy_allowed]);

  if (!guard || !guard.high) return null;
  const atTop = price >= guard.ceiling;
  const coin = pair.split('-')[0];

  const toggle = async () => {
    if (!guard.enabled || saving) return;
    setSaving(true);
    try {
      const { data } = await axios.post(`${API_V2}/user/bot/toggle-high-guard`, { pair }, { withCredentials: true });
      setAllowed(data.high_buy_allowed);
      toast.success(data.high_buy_allowed ? `${coin}: High buy allowed` : `${coin}: Buys blocked near ${guard.days}D high`);
    } catch (e) {
      toast.error('Failed to toggle guard', { description: e.response?.data?.detail || e.message });
    } finally {
      setSaving(false);
    }
  };

  const status = !guard.enabled
    ? { label: 'GUARD OFF', cls: 'text-gray-500' }
    : allowed
      ? { label: '● HIGH BUY ALLOWED', cls: 'text-yellow-400 font-bold' }
      : atTop
        ? { label: '● BUY BLOCKED', cls: 'text-red-400 font-bold animate-pulse' }
        : { label: 'BUY OK (GUARDED)', cls: 'text-green-400' };
  const box = guard.enabled && !allowed && atTop
    ? 'border-red-500/60 bg-red-900/20 hover:bg-red-900/40'
    : guard.enabled && allowed
      ? 'border-yellow-500/60 bg-yellow-900/10 hover:bg-yellow-900/30'
      : 'border-[#003B00] hover:bg-[#001a00]';

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={!guard.enabled || saving}
      title={guard.enabled ? 'Click to toggle between Buy Blocked and High Buy Allowed' : 'Enable the guard in Settings → Protection'}
      className={`mt-2 w-full text-left flex flex-wrap items-center gap-x-3 gap-y-1 text-xs border px-2 py-1 rounded transition-colors ${box} ${guard.enabled ? 'cursor-pointer' : 'cursor-not-allowed'} ${saving ? 'opacity-60' : ''}`}
      data-testid={`high-guard-badge-${pair}`}
    >
      <span>
        <span className="text-[#008F11]">{guard.days}D HIGH: </span>
        <span className="text-[#00FF41]" data-testid={`high-guard-high-${pair}`}>${formatPrice(guard.high, pair)}</span>
      </span>
      <span>
        <span className="text-[#008F11]">BUY CEILING: </span>
        <span className="text-yellow-400" data-testid={`high-guard-ceiling-${pair}`}>${formatPrice(guard.ceiling, pair)}</span>
      </span>
      <span className={status.cls} data-testid={`high-guard-status-${pair}`}>{saving ? '...' : status.label}</span>
    </button>
  );
};
